
// 角色权限弹框
import React, { Component } from 'react';
import { message, Modal, Form, Input, Button, Table, Popconfirm } from 'antd';
import '../../../static/css/index.css'
import { getRoleUserList, deleteUser } from '../../../apis/api'

import AddUser from './addUser'
import UpdateUserPrivilege from './updateUserPrivilege'

class RoleUser extends Component {
  constructor(props) {
    super(props);
    this.state={
        access_token:'',
        flag:false,
        search_params:{},
        roleUserList:[],
        currentPage:1,
        currentPageSize:10,
        total:0,
        add_user_visible:false,//按员工授权modal是否打开
        update_user_visible:false,//修改员工权限modal是否打开
        details:{}
    }
  }

  componentDidMount(){
    
    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
        if(this.props.visible&&this.props.role_uuid){
            this.getRoleUserList(null,this.props.role_uuid);
        }

    })

  }

  
  componentWillReceiveProps(nextProps) { 

    if(nextProps.visible&&nextProps.role_uuid&&nextProps.role_uuid!==this.props.role_uuid){
        this.getRoleUserList(null,nextProps.role_uuid);
    }

  }

  getRoleUserList(obj,role_uuid){
    let _this=this;
    this.setState({flag:true})
    const { access_token, currentPage, currentPageSize } = this.state;
    let params={
        access_token:access_token,
        role_uuid:role_uuid?role_uuid:_this.props.role_uuid,
        name:obj&&obj.name?obj.name:'',
        mobile:obj&&obj.mobile?obj.mobile:'',
        username:obj&&obj.username?obj.username:'',
        page:currentPage,
        page_size:currentPageSize
    }
    getRoleUserList(params).then( (data)=> {

        if(data.code === 0){

            let roleUserList=data.content.list;
            let total=data.content.paging.total_record;
            _this.setState({ roleUserList, total, flag:false })

        }else{

            message.error(data.message); 
        }
    });

  }

    //按员工授权
    addUser = ()=>{
        this.setState({
            add_user_visible:true,
        });
    }
    
    //修改员工权限
    updateUser(obj){
        this.setState({
            update_user_visible:true,
            details:obj
        });
        
    }
    
      
      // 删除员工
      deleteUser(uuid){
        let _this=this;
        let params={
          access_token:_this.state.access_token,
          user_uuid:uuid,
          role_uuid:_this.props.role_uuid
        }
        deleteUser(params).then( (data)=> {
        if(data.code===0){
            message.success('删除员工成功！');
            _this.setState({currentPage:1},()=>{
                _this.getRoleUserList(_this.state.search_params);
            })
        }else{
            message.error(data.message);
      }
    });
    
        
      }

    // 关闭弹窗
    handleCancel = (e) => {
        this.setState({
            add_user_visible:false,
            update_user_visible:false,
            details:{}
        });
      }   

  //页码变化
  handleTableChange = pagination => {
    var _this = this;
    const current = pagination.current || 1;
    this.setState({ currentPage: current },()=>{
        _this.getRoleUserList(_this.state.search_params);
    });
  }
  
  //搜索
  searchUser = () =>{
    let _this=this;
    _this.props.form.validateFields((err, values) => {
      if(err) {
          console.log('submit error:' ,err);
      }else {
        _this.setState({currentPage:1,search_params:values},()=>{
            _this.getRoleUserList(values);
        })
      }
    });
  }

  // 点击确定、取消按钮
  handleOk = (e) => {
    this.props.cancelModal();
  }

  
  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible, role_uuid, role_name } = this.props;
    const { currentPage, curPageSize, total, roleUserList, flag, add_user_visible, update_user_visible, details } = this.state;

    const columns=[{
    //     title: '角色uuid',
    //     dataIndex: 'role_uuid',
    //     width:'20%',
    //     align:'center',
    //   }, {
        title: '角色名称',
        dataIndex: 'role_name',
        width:'15%',
        align:'center',
      },{
        title: '部门',
        dataIndex: 'org_name',
        width:'14%',
        align:'center',
      },{
        title: '职位',
        dataIndex: 'job_type',
        width:'14%',
        align:'center',
      }, {
        title: '用户名称',
        dataIndex: 'name',
        width:'10%',
        align:'center',
      }, {
        title: 'oa账号',
        dataIndex: 'username',
        width:'13%',
        align:'center',
      }, {
        title: '手机号',
        dataIndex: 'mobile',
        width:'14%',
        align:'center',
        },{
        title: '操作',
        dataIndex: 'operation',
        width:'20%',
        align:'center',
        render:(text, record,index) => (<div style={{display:'flex',justifyContent:'center'}}>
           <p><a style={{marginRight:10}} onClick={this.updateUser.bind(this,record)}>修改员工权限</a></p>
           <p>
             <Popconfirm title="确认删除该员工吗?" okText="确认" cancelText="取消" onConfirm={()=>this.deleteUser(record.user_uuid)} onCancel={()=>{}}>
                 <a>删除</a>
             </Popconfirm>
           </p>
        </div>)
    }];

    return (

       <div className='role_user_form'>
         <Modal
            title="授权"
            visible={visible}
            onCancel={this.handleOk}
            footer={null}
            width={'80%'}
         >
       
          <div className='search_form'>
            <Form layout="inline">
                <Form.Item label="手机号">
                    {getFieldDecorator('mobile', {
                        initialValue:''
                    })(
                        <Input placeholder='请输入手机号' style={{width:200}} onPressEnter={this.searchUser} />
                    )}
                </Form.Item>

                <Form.Item label="oa账号">
                    {getFieldDecorator('username', {
                        initialValue:''
                    })(
                        <Input placeholder='请输入oa账号' style={{width:200}} onPressEnter={this.searchUser} />
                    )}
                </Form.Item>

                <Form.Item label="用户名">
                    {getFieldDecorator('name', {
                        initialValue:''
                    })(
                        <Input placeholder='请输入用户名' style={{width:200}} onPressEnter={this.searchUser} />
                    )}
                </Form.Item>

                <Form.Item>
                   <Button type='primary' onClick={this.searchUser}>搜索</Button>
                </Form.Item>

            </Form>
          </div>

          <div className="add_btn">
              <Button type="primary" onClick={this.addUser}>按员工授权</Button>
          </div>

          <div className="layout_content_table">
                <Table rowKey='id' scroll={{ y: 400 }} columns={columns} dataSource={roleUserList} loading={flag} 
                       pagination={{
                            current: currentPage,
                            pageSize: curPageSize,
                            total: total
                       }}
                        onChange={this.handleTableChange}/>
          </div>

          {add_user_visible?
             <AddUser visible={add_user_visible} role_uuid={role_uuid} role_name={role_name} cancelModal={this.handleCancel} getRoleUserList={this.searchUser}/>
          :''}

          <UpdateUserPrivilege visible={update_user_visible} role_uuid={role_uuid} details= {details} cancelModal={this.handleCancel} getRoleUserList={this.searchUser}/>
    
         </Modal>

       </div>
    );
  }
}

RoleUser = Form.create({
   
})(RoleUser);
export default RoleUser;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/roleUser.js